import { render, staticRenderFns } from "./05-SingleSummary.vue?vue&type=template&id=fc82c030&scoped=true&"
import script from "./05-SingleSummary.vue?vue&type=script&lang=js&"
export * from "./05-SingleSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc82c030",
  null
  
)

export default component.exports